export const grupoPerguntas = ({ grupo_perguntas }) => grupo_perguntas;